<template>
  <vue-tel-input
    :class="{ 'is-invalid': errorMessage, valid: meta.valid }"
    v-model.lazy="value"
    @on-input="onInput"
    @blur="handleBlur"
    @validate="onValidate"
  />
  <span v-if="errorMessage && meta.touched" class="error-message">{{ errorMessage }}</span>
</template>

<script setup>
import { useField } from 'vee-validate'
import { computed, useAttrs, useSlots, watch } from 'vue'

const props = defineProps({
  name: { type: String, required: true },
})

const emit = defineEmits(['validate'])

const onValidate = (phoneObject) => {
  console.log('Validating Phone input internal:', phoneObject, phoneObject.valid);
  emit('validate', phoneObject.valid);
}

const onInput = async (number, phoneObject) => {
  console.log('Phone input changed:', number, phoneObject);
  // await validate();
}

const validation = () => {
  return "Not ok phone";
  /*console.log('Validating Phone input', valid);
  return valid ? true : 'Invalid phone number';*/
}

const { value, errorMessage, meta, handleChange, handleBlur } = useField(props.name)

</script>

<style scoped>
.is-invalid {
  border-color: #dc3545;
}
.error-message {
  color: #dc3545;
  font-size: 0.875em;
}

.valid {
  border: 1px solid green !important;
}
</style>
